import Swiper, { Navigation, Pagination, Autoplay, Controller } from 'swiper';

function init() {
  Swiper.use([Navigation, Pagination, Autoplay, Controller]);
  var acfeLayoutSlug = 'image_grid';
  var $layouts = $('.layout-image-grid');
  var swiperSelector = '.swiper';
  var swiperOptions = {
    slidesPerView: 'auto',
    spaceBetween: 20,
    centeredSlides: true,
    loop: true,
    speed: 800,
    pagination: {
       el: '.swiper-pagination',
       clickable: true,
    },
  };

  var initSwiperForLayout = function($layout) {
    var $swiper = $layout.find(swiperSelector);
    if($swiper.attr('data-autoplay')) {
      swiperOptions.autoplay = {};
      swiperOptions.autoplay.delay = parseFloat($swiper.attr('data-autoplay'));
      swiperOptions.autoplay.pauseOnMouseEnter = true;
    }

    var swiper = new Swiper($swiper.get(0), swiperOptions);
  };

  $layouts.each(function() {
    initSwiperForLayout($(this));
  });

  window.acf && window.acf.addAction('acfe/fields/flexible_content/preview/name=layouts&layout=' + acfeLayoutSlug, function(response, $flexible, $layout, ajaxData) {
    initSwiperForLayout($layout);
  });
}

export default init;



// WEBPACK FOOTER //
// ./scripts/flexible-content/imageGrid.js